import SearchBar from './SearchBar.jsx';
export default SearchBar;
